import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/react-start'
import {z} from 'zod'
import fetchLegalPage from '~/client/sanity/fetchLegalPage'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 * 6 // 6h

const legalPageContentParams = z.object({
    locale: z.nativeEnum(Locale).optional(),
    type: z.enum(['terms-and-conditions', 'legal', 'privacy']),
})

const getLegalPageContent = createServerFn({
    method: 'GET',
})
    .inputValidator((data: unknown) => {
        const result = legalPageContentParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }

        return result.data
    })
    .handler(async ({data}) => {
        const {locale, type} = data ?? {}
        const legalPageContent = await fetchLegalPage(type, locale)

        applyServerFnCache(CACHE_TIME_SEC)

        return legalPageContent
    })

export default getLegalPageContent
